export const getClientId = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  return urlSearchParams.get('clientId') || undefined;
};
